import React, { useRef, useState } from 'react';
import { Box, IconButton, MenuItem, Stack } from '@mui/material';
import MenuPopover from '../../../shared/components/menuPopover';
import { RegionService } from '../../../../../../services/regionService';
import { useEffect } from 'react';
import { Regions } from '../../../../../../config/regions';

export default function RegionPopover() {
	const regionService = new RegionService();
	const anchorRef = useRef(null);
	const [currentRegion, setCurrentRegion] = useState(Regions[0]);
	const [open, setOpen] = useState(false);

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	useEffect(() => {
		let currentRegion = regionService.currentRegion();
		setCurrentRegion(Regions.find((resp) => resp.code === currentRegion));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<IconButton
				ref={anchorRef}
				onClick={handleOpen}
				className="!bg-white shadow-xl"
				color={open ? 'primary' : 'default'}
				sx={{ width: 36, height: 36 }}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
					<img
						width={'30px'}
						src={currentRegion?.icon}
						alt={currentRegion?.label}
					/>
				</Box>
			</IconButton>

			<MenuPopover
				open={open}
				onClose={handleClose}
				anchorEl={anchorRef.current}
				sx={{
					mt: 1.5,
					ml: 0.75,
					width: 180,
					'& .MuiMenuItem-root': {
						px: 1,
						typography: 'body2',
						borderRadius: 0.75,
					},
				}}>
				<Stack spacing={0.75}>
					{Regions.map((option, index) => (
						<Box key={index}>
							<MenuItem
								key={option.code}
								selected={currentRegion?.code === option.code}
								onClick={() => {
									handleClose();
									regionService.setRegion(option.code);
								}}>
								<Box
									component="img"
									alt={option.name}
									src={option.icon}
									sx={{ width: 20, mr: 2 }}
								/>

								{option.name}
							</MenuItem>
						</Box>
					))}
				</Stack>
			</MenuPopover>
		</>
	);
}
